import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Article1 from "./pages/Article1";
import Article2 from "./pages/Article2";
import Article3 from "./pages/Article3";
import Article4 from "./pages/Article4";
import Article5 from "./pages/Article5";
import Article6 from "./pages/Article6";
import Article7 from "./pages/Article7";
import Article8 from "./pages/Article8";
import Article9 from "./pages/Article9";
import ArticleTemplate from "./pages/ArticleTemplate";
import { LanguageProvider } from "./components/LanguageContext";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <LanguageProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/article/1" element={<Article1 />} />
          <Route path="/article/2" element={<Article2 />} />
          <Route path="/article/3" element={<Article3 />} />
          <Route path="/article/4" element={<Article4 />} />
          <Route path="/article/5" element={<Article5 />} />
          <Route path="/article/6" element={<Article6 />} />
          <Route path="/article/7" element={<Article7 />} />
          <Route path="/article/8" element={<Article8 />} />
          <Route path="/article/9" element={<Article9 />} />
          <Route path="/article/:id" element={<ArticleTemplate />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </HashRouter>
      </LanguageProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
